document.addEventListener('DOMContentLoaded', function() {
  const initSwiper = () => {
    const swiperContainers = document.querySelectorAll('.collection-slider__wrapper.swiper:not(.swiper-initialized)');
    
    swiperContainers.forEach(container => {
      // Default options for Swiper
      const defaultOptions = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24
          }
        },
        pagination: {
          el: container.querySelector('.product-slider-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: container.closest('.collection-slider__main-container').querySelector('.product-slider-button-next'),
          prevEl: container.closest('.collection-slider__main-container').querySelector('.product-slider-button-prev')
        }
      };

      // Get custom options from data-attribute if any
      let customOptions = {};
      try {
        customOptions = JSON.parse(container.getAttribute('data-swiper-options') || '{}');
      } catch (e) {
        console.error('Failed to parse Swiper options:', e);
      }

      const finalOptions = Object.assign({}, defaultOptions, customOptions);

      try {
        const swiper = new Swiper(container, finalOptions);
      } catch (e) {
        console.error('Swiper initialization failed:', e);
      }
    });
  };

  if (typeof Swiper === 'undefined') {
    const script = document.querySelector('script[src*="swiper"]');
    if (script) {
      script.addEventListener('load', initSwiper);
    }
  } else {
    initSwiper();
  }

  // Support for Shopify Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('collection-slider') || event.target.querySelector('.collection-slider')) {
      console.log('Shopify section load, re-initializing Swiper');
      initSwiper();
    }
  });
});
